import Navigation from './router/Navigation';

const App = () => <Navigation lang='en' />

export default App;
